import Vue from 'vue'
import Vuex from 'vuex'
// 引入vuex持久化
import createPersistedState from 'vuex-persistedstate'
import createLogger from 'vuex/dist/logger'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import im from './modules/im'
// import * as Cookies from 'js-cookie'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// 使用sessionStorage的vuex持久化实例
const createPersisted = createPersistedState({
  storage: window.sessionStorage,
  // eslint-disable-next-line
  // 移除sessionState储存的device
  reducer: vuexState => {
    let sessionState = Object.assign({}, vuexState)

    for (let key in sessionState) {
      if (key === 'deviceOpenId' || key === 'deviceUserDetails' || key === 'im') {
        delete sessionState[key]
      }
    }
    return sessionState
  }
})
// 使用localStorage的vuex持久化实例
const createStorage = createPersistedState({
  storage: window.localStorage,
  // eslint-disable-next-line
  reducer: vuexState => {
    // localStorage只储存device信息
    return {
      deviceOpenId: vuexState.deviceOpenId,
      deviceUserDetails: vuexState.deviceUserDetails
    }
  }
})


export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    im
  },
  // strict: debug,
  plugins: debug ? [createLogger(), createStorage, createPersisted] : [createStorage, createPersisted]
})



// WEBPACK FOOTER //
// ./src/store/index.js